import {
  getPlayerBaseFromPlayerStat,
  getSortedPlayers,
  mapProperties
} from 'app/utils/entities/match_data';
import { roundForDisplay } from 'app/utils/number';

const getOpponentsPlayerStatData = <T extends StatPlayer>(
  data: PlayersStatsBlockMatch
): [PlayerStatData<T | null>[], PlayerStatData<T | null>[]] => {
  const opponent1Players = getSortedPlayers(data?.opponents.at(0)) as (T | null)[];
  const opponent2Players = getSortedPlayers(data?.opponents.at(1)) as (T | null)[];

  let statsProperties: StatProperties<T | null>[] = [];

  switch (data.videogame_slug) {
    case 'dota-2': {
      const properties: StatProperties<StatPlayerDota2>[] = [
        { name: 'average_kda', displayFunction: roundForDisplay(2) },
        { name: 'average_gold_per_minute', displayFunction: roundForDisplay(0) },
        { name: 'average_xp_per_minute', displayFunction: roundForDisplay(0) },
        {
          name: 'average_creep_score_per_minute',
          displayFunction: roundForDisplay(0)
        },
        { name: 'average_denies_per_minute', displayFunction: roundForDisplay(2) }
      ];
      statsProperties = properties as StatProperties<T | null>[];
      break;
    }
    case 'cs-go': {
      const properties: StatProperties<StatPlayerCs>[] = [
        { name: 'kd_ratio', displayFunction: roundForDisplay(2) },
        { name: 'average_damage_per_round', displayFunction: roundForDisplay(2) },
        { name: 'average_headshots_per_game', displayFunction: roundForDisplay(2) },
        { name: 'average_clutch_rounds_won_per_game', displayFunction: roundForDisplay(2) },
        { name: 'kast', displayFunction: roundForDisplay(0, '%') }
      ];
      statsProperties = properties as StatProperties<T | null>[];
      break;
    }
  }

  const opponent1PlayersStats = opponent1Players.map(player => ({
    ...getPlayerBaseFromPlayerStat(player),
    stats: mapProperties<T>(statsProperties, player)
  })) as PlayerStatData<T | null>[];

  const opponent2PlayersStats = opponent2Players.map(player => ({
    ...getPlayerBaseFromPlayerStat(player),
    stats: mapProperties<T>(statsProperties, player)
  })) as PlayerStatData<T | null>[];

  return [opponent1PlayersStats, opponent2PlayersStats];
};

export { getOpponentsPlayerStatData };
